"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ReactIdSwiper_1 = __importDefault(require("./ReactIdSwiper")); // React-id-swiper


exports["default"] = ReactIdSwiper_1["default"];